var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-content"},[_vm._l((_vm.arr),function(item,index){return [_c('img',{class:{'no-shadow':_vm.arr.length===1},style:(_vm.changePostion(index)),attrs:{"src":_vm.changeThumb(item,116,80),"alt":""}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }